import React from "react";
import style from "./Account.module.scss";
import { FormattedNumber } from "../../../../FormattedNumber/FormattedNumber";
import { Badge } from "reactstrap";

const Balance = ({ balance }) => {
  return (
    <div className={style.balance}>
      {balance.map(
        (item, index) =>
          item.key !== "" && (
          <div className={style.line}>            
            <div key={`bitem-${index}`} className={style.item}>
              <span>{item.key}</span>
              <FormattedNumber value={item.value} dataTypeDecimalName="currency" />
              {(item.booktype !== "" && item.booktype !== undefined) && <Badge color={ "success"} className={style.pending}> {item.booktype} </Badge>}
            </div>
            </div>
          )
      )}
    </div>
  );
};

export default Balance;
